import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { player } from 'src/client/player';
import { useStores } from 'src/common/providers';
import secondsToTime from 'src/common/utils/secondsToTime';
import { selectIsMobile } from '../../../../selectors/app';
import DefaultScrubber from './DefaultScrubber';
import LiveSeekScrubber from './LiveSeekScrubber';

const sliderMax = 100;

export default function Scrubber({ isInNowPlayingDialog, className }) {
  const { playerStore } = useStores();
  const metadata = playerStore.metadata();
  const isVideoAdLoaded = playerStore.isVideoAdLoaded();
  const isLive = (metadata?.isLive ?? true) || isVideoAdLoaded;
  const isMobile = useSelector(selectIsMobile);
  const duration = playerStore.duration();
  const currentTime = playerStore.currentTime();
  const newPositionInfo = {
    duration,
    elapsedSeconds: currentTime,
    elapsedPercent: duration ? (currentTime / duration) * 100 : 0,
    isLiveSeekStream: metadata?.isLiveSeek,
  };

  const { elapsedSeconds = 0, elapsedPercent = 0, isLiveSeekStream } = newPositionInfo;
  const elapsedTime = secondsToTime(elapsedSeconds);
  const durationTime = secondsToTime(duration);

  if (isLiveSeekStream && !isMobile) {
    return (
      <LiveSeekScrubber
        isLive={isLive}
        sliderMax={sliderMax}
        elapsedTime={elapsedTime}
        durationTime={durationTime}
        elapsedPercent={elapsedPercent}
        elapsedSeconds={elapsedSeconds}
        onChangeCommitted={player.seekTo}
      />
    );
  }

  return (
    <DefaultScrubber
      sliderMax={sliderMax}
      elapsedTime={elapsedTime}
      durationTime={durationTime}
      elapsedPercent={elapsedPercent}
      elapsedSeconds={elapsedSeconds}
      onChangeCommitted={player.seekTo}
      isInNowPlayingDialog={isInNowPlayingDialog}
      className={className}
      isLive={isLive}
    />
  );
}

Scrubber.propTypes = {
  isInNowPlayingDialog: PropTypes.bool,
  className: PropTypes.string,
};
